import { AnimatePresence } from "framer-motion";
import { useModal } from "../../context/ModalContext";
import OktoberfestModal from "./oktoberfest/OktoberfestModal";


const ModalRoot = () => {
    const { activeModal, closeModal } = useModal();

    return (
        <AnimatePresence>
            {activeModal === "oktoberfest" && (
                <OktoberfestModal onClose={closeModal} />
            )}
            {/* Qui in futuro puoi aggiungere altri modali */}
        </AnimatePresence>
    );
};

export default ModalRoot;
